import { Badge, Col, Row } from "react-bootstrap";

import './ArticlePreview.css';

function ArticlePreview(props: any) {
    return (
        <>
            {
                props.pageSlice.map((id: any) => {
                    try {
                        var article = props.metadata[id];
                        return (
                            <div className='position-relative' key={Math.random()}>
                                <Row>
                                    <Col xs={3} className='text-center'>
                                        <img src={((article.cover === '' || article.cover === undefined) ? '../assets/defualt-image.png' : '../assets/images/' + article.cover)} alt='' onError={(e: any) => e.target.src = '../assets/defualt-image.png'} className='home-image-view' />
                                    </Col>
                                    <Col xs={9}>
                                        <h2 className='articlepreview-article-title'>{article.title}</h2>
                                        <p>{article.time} by <span className='text-primary'>{article.author}</span></p>
                                        <div className='articlepreview-article-description'>
                                            <span>{article.description}</span><br />
                                            <span>
                                                {
                                                    article.tag.map((tag: string) => {
                                                        return <span key={Math.random()}> <Badge bg="secondary">{tag}</Badge></span>;
                                                    })
                                                }
                                            </span>
                                        </div>
                                        <a href={'/article/' + id} className='stretched-link'> </a>
                                    </Col>
                                </Row>
                                <hr />
                            </div>
                        );
                    }
                    catch (error) {}

                    return <></>;
                })
            }
        </>
    );
}

export default ArticlePreview;